<app-cardholder-details
  *ngIf="cardholder"
  [cardholder]="cardholder"
  (newCardholderSelected)="showNewCardholder($event)"
>
</app-cardholder-details>

<div
  id="trans_hist_search"
  class="card card-nc"
  *ngIf="
    hasEntitlements('CARDHOLDERS_HISTORY_TRANSACTIONS') && cardholderDetails
  "
>
  <div class="card-heading">
    <span class="icon-NC_history"></span>
    <span class="transactionHistHeader">&nbsp;TRANSACTION HISTORY SEARCH</span>
    <span class="alignRight subPanelHeaderHeading lastPwdLabelBox">
      <div class="col-md-12 colAdj lastPassword lastPasswordCenter">
        Current as of
      </div>
      <div class="col-md-12 colAdj lastPassword">
        {{
          cardholderDetails.identity.currentShip.lastRoundtrip
            | date: "fullDate"
        }}
      </div>
    </span>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-4 form-group">
        <label for="acctFilter" class="labelCommon">ACCOUNT</label>
        <span>
          <select
            class="form-control input-sm"
            name="acctFilter"
            id="acctFilter"
            [(ngModel)]="acctFilter"
            (change)="filterTransactions()"
          >
            <option value="0">All</option>
            <option
              *ngFor="let acct of cardholderDetails.customerAccounts"
              [value]="acct.account"
            >
              {{ acct.account + " - " + acct.type }}
            </option>
          </select>
        </span>
      </div>

      <!-- /input-group -->
      <div class="form-group col-md-4">
        <label for="tranMinDate" class="labelCommon">START DATE</label>
        <div class="input-group datepicker dtpicker-btn">
          <input
            id="tranMinDate"
            class="form-control"
            name="tranMinDate"
            [maxDate]="endDate"
            [(ngModel)]="startDate"
            (change)="loadTransactionHistory()"
            ngbDatepicker
            #d1="ngbDatepicker"
            (ngModelChange)="loadTransactionHistory()"
            readonly="readonly"
            (click)="d1.toggle()"
          />
          <div class="input-group-append">
            <button
              class="fa fa-calendar"
              (click)="d1.toggle()"
              type="button"
            ></button>
          </div>
        </div>
      </div>
      <div class="form-group col-md-4">
        <label for="tranMaxDate" class="labelCommon">END DATE</label>
        <div class="input-group datepicker dtpicker-btn">
          <input
            id="tranMaxDate"
            class="form-control"
            name="tranMinDate"
            [minDate]="startDate"
            [(ngModel)]="endDate"
            (change)="loadTransactionHistory()"
            ngbDatepicker
            #d2="ngbDatepicker"
            (ngModelChange)="loadTransactionHistory()"
            readonly="readonly"
            (click)="d2.toggle()"
          />
          <div class="input-group-append">
            <button
              class="fa fa-calendar"
              (click)="d2.toggle()"
              type="button"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<br /><br />

<div
  class="table-responsive"
  *ngIf="hasEntitlements('CARDHOLDERS_HISTORY_TRANSACTIONS')"
>
  <table class="table tableBackground tableRow table-bordered table-hover">
    <thead class="transactionHistHeader tableheading">
      <tr>
        <th class="text-center col-2">DATE</th>
        <th class="text-center col-2">POSTED</th>
        <th class="text-center col-1">TYPE</th>
        <th class="text-center col-4">DESCRIPTION</th>
        <th class="text-center col-2">AMOUNT</th>
        <th class="text-center col-2">BALANCE</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="transLoading">
        <td colspan="7" style="text-align: center; height: 150px">
          <i class="fa fa-spinner fa-2x fa-pulse"></i>
        </td>
      </tr>
      <tr *ngIf="dbTransactions.length === 0 && !transLoading">
        <td colspan="7" style="text-align: center; height: 150px">
          No account activity found.
        </td>
      </tr>
      <ng-container
        *ngFor="
          let transaction of dbTransactions;
          index as i;
          trackBy: trackByTransSeq
        "
      >
        <tr *ngIf="!transLoading">
          <td class="transactionHistText text-center col-2">
            {{ transaction.tran.date | date: "mediumDate" }}
          </td>
          <!-- pattern="MM/dd/yyyy" -->
          <td class="transactionHistText text-center col-2">
            {{ transaction.tran.postDate | date: "mediumDate" }}
          </td>
          <td
            class="transactionHistText text-center col-1"
            *ngIf="transaction.tran.account != payrollAccount"
          >
            Chip
          </td>
          <td
            class="transactionHistText text-center col-1"
            *ngIf="transaction.tran.account == payrollAccount"
          >
            Strip
          </td>
          <td class="transactionHistText text-left col-4">
            {{ transaction.tran.descr }}
            <span
              style="float: right"
              *ngIf="transaction.tran.reverseState == -1"
              [ngClass]="{
                greenBackGround: transaction.tran.amount >= 0.0,
                redBackGround: transaction.tran.amount < 0.0
              }"
            >
              R
            </span>
          </td>
          <td
            class="text-center col-2"
            [ngClass]="{
              'text-success': transaction.tran.amount >= 0.0,
              'text-fail': transaction.tran.amount < 0.0
            }"
          >
            {{ transaction.tran.amount | currency | minusSignToParens }}
          </td>
          <td
            class="text-center col-2"
            [ngClass]="{
              'text-success': transaction.tran.balance >= 0.0,
              'text-fail': transaction.tran.balance < 0.0
            }"
          >
            {{ transaction.tran.balance | currency | minusSignToParens }}
          </td>

          <td>
            <a>
              <i
                *ngIf="!transaction.expanded"
                class="fa fa-plus-square"
                (click)="transaction.expanded = true; showDetails(transaction)"
              >
              </i>
              <i
                *ngIf="transaction.expanded"
                class="fa fa-minus-square"
                (click)="transaction.expanded = false"
              >
              </i>
            </a>
          </td>
        </tr>
        <tr
          *ngIf="
            transaction.expanded &&
            (transaction.tran.account.toString() === acctFilter ||
              showAllTrans) &&
            !transLoading
          "
        >
          <td colspan="5">
            <div *ngIf="transaction.c2cDetails != ''">
              {{ transaction.c2cDetails }}
            </div>
            <div *ngFor="let tranDetail of transaction.tranDetails | keyvalue">
              <span class="transactionHistText">
                <strong>{{ tranDetail.key }}</strong
                >&nbsp;{{ tranDetail.value }}
              </span>
            </div>
          </td>
          <td
            colspan="2"
            *ngIf="
              transaction.tran.reverseState !== -1 &&
              transaction.tran.reverseState !== 0 &&
              transaction.tran.reverseType === 1 &&
              hasEntitlements('CARDHOLDERS_HISTORY_TRANSACTION_REVERSE')
            "
            class="text-center"
          >
            <app-confirm-button-combo
              [addSyncFixed]="false"
              [baseLabel]="' Reverse '"
              (confirmSelected)="reverse(transaction.tran)"
              [commit_btn_spinner]="applyReverseButtonSpinnerString"
            >
            </app-confirm-button-combo>
          </td>
          <td
            colspan="2"
            *ngIf="transaction.tran.reverseState == -1"
            class="reverseSection"
          >
            Has Been Reversed
          </td>
          <td
            colspan="2"
            *ngIf="
              transaction.tran.reverseState != -1 &&
              !hasEntitlements('CARDHOLDERS_HISTORY_TRANSACTION_REVERSE')
            "
          ></td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
